import { TThunkAction } from '../../../../common/types/thunk';
import { EServiceId } from '../../../types/reducers/publishTerms';
import { ECheckServicePromotionType, ECheckServicePublicationType } from '../../../services/checkService';
import { selectCompetitorsExperiment } from '../../../selectors/experiments';
import { changeSelectedServiceAfterCheckServiceV1 } from './changeSelectedServiceAfterCheckServiceV1';
import { changeSelectedServiceAfterCheckServiceV2 } from './changeSelectedServiceAfterCheckServiceV2';

interface IParams {
  publicationType: ECheckServicePublicationType;
  promotionType: ECheckServicePromotionType;
  serviceId: EServiceId;
}

export const changeSelectedServiceAfterCheckService =
  (params: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, extraArgument) => {
    const useV2 = selectCompetitorsExperiment(getState());

    if (useV2) {
      await changeSelectedServiceAfterCheckServiceV2(params)(dispatch, getState, extraArgument);
    } else {
      await changeSelectedServiceAfterCheckServiceV1(params)(dispatch, getState, extraArgument);
    }
  };
